import * as React from 'react';
import ReactModal from 'react-modal';

import { ProlongationPopupCloseIcon } from './ProlongationPopupCloseIcon';
import { ProlongationPopupHeader } from './ProlongationPopupHeader';
import { ProlongationPopupMultipleContent } from './ProlongationPopupMultipleContent';
import { ProlongationPopupSingleContent } from './ProlongationPopupSingleContent';

export interface IProlongationPopupModalProps {
  address: string;
  announcementUrl: string;
  isOpen: boolean;
  hasMultiple: boolean;
  operationType: string;
  realtyObjectId: number;
  onClose(): void;
}

export const ProlongationPopupModal: React.FC<IProlongationPopupModalProps> = ({
  address,
  announcementUrl,
  isOpen,
  hasMultiple,
  operationType,
  realtyObjectId,
  onClose,
}) => (
  <ReactModal
    isOpen={isOpen}
    ariaHideApp={false}
    shouldCloseOnOverlayClick
    onRequestClose={onClose}
    style={{
      content: {
        backgroundColor: 'white',
        borderRadius: '4px',
        boxShadow: '0 5px 15px 0 rgba(186, 186, 186, 0.5)',
        overflow: 'visible',
        padding: '24px 32px 44px',
        position: 'relative',
        width: '510px',
        top: 0,
        right: 0,
        left: 0,
        bottom: 0,
        zIndex: 10001,
      },
      overlay: {
        alignItems: 'center',
        backgroundColor: 'rgba(24, 41, 48, .8)',
        display: 'flex',
        justifyContent: 'center',
        zIndex: 10000,
      },
    }}
  >
    <ProlongationPopupCloseIcon onClick={onClose} />
    <ProlongationPopupHeader />

    {hasMultiple ? (
      <ProlongationPopupMultipleContent operationType={operationType} />
    ) : (
      <ProlongationPopupSingleContent id={realtyObjectId} announcementUrl={announcementUrl} address={address} />
    )}
  </ReactModal>
);
